"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusSchema = void 0;
const zod_1 = require("zod");
const LineStyle_1 = require("./LineStyle");
const DrawingBase_1 = require("./DrawingBase");
const XYPosition_1 = require("./XYPosition");
exports.BusSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('bus'),
    start: XYPosition_1.XYPositionSchema,
    end: XYPosition_1.XYPositionSchema,
    width: zod_1.z.number(),
    style: LineStyle_1.LineStyleSchema.optional(),
    curve: zod_1.z.number().optional(),
});
//# sourceMappingURL=Bus.js.map